export const TestData = [
  {
    title: "Project-idea",
    subtitle: "Fullstack Project",
    filepath: "/project/project-idea.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Project-order",
    subtitle: "Fullstack Project",
    filepath: "/project/order.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Spring vs SpringBoot",
    subtitle: "what is it",
    filepath: "/Spring/springspringboot.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Spring Refresher Project",
    subtitle: "Bean,Autowiring???",
    filepath: "/Microservices/ref.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Maven vs Gradle",
    subtitle: "what is it",
    filepath: "/Spring/MG.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Java Servlet",
    subtitle: "what is it",
    filepath: "/Spring/jar.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Apache Tomcat",
    subtitle: "Spring Apache Tomcat",
    filepath: "/Spring/tc.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "SQL",
    subtitle: "SQL Basics",
    filepath: "/Spring/SQL.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Java Basics",
    subtitle: "Spring Framework Prerequisites",
    filepath: "/Spring/spring-prereq.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Core Java Spring",
    subtitle: "Some basic tasks",
    filepath: "/Spring/Core-java-Spring-task.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Spring-Basics",
    subtitle: "Spring Framework Prerequisites",
    filepath: "/Spring/spring-basics.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Spring-Prerequisite-Basics",
    subtitle: "Spring Framework Prerequisites",
    filepath: "/Spring/spring-prereq.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Spring-Purpose",
    subtitle: "why do we need Spring",
    filepath: "/Spring/spring-purpose.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Hibernate",
    subtitle: "what is hibernate ",
    filepath: "/Spring/hib.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Controller Layer",
    subtitle: "API endpoints",
    filepath: "/Spring/Controller.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Service Layer",
    subtitle: "Bussiness logic",
    filepath: "/Spring/Service.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Repository(talks Database)",
    subtitle: "what is JPA vs Crud ",
    filepath: "/Spring/jpavscrud.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Query Derived Method",
    subtitle: "why we use optional ",
    filepath: "/Spring/query.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Spring-Dependencies",
    subtitle: "what are these dependencies",
    filepath: "/Spring/spring-dependencies.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Exceptional Handling",
    subtitle: "error catching",
    filepath: "/Spring/Exception.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Validation Handling",
    subtitle: "Notnull,valid,size",
    filepath: "/Spring/Validation.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Data Input- app ready ",
    subtitle: "you can use anywhere",
    filepath: "/Spring/data.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },

  {
    title: "Project-Step-1: Application prop ",
    subtitle: "Adding application properties ",
    filepath: "/Spring/appprop.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Project-Steps ",
    subtitle: "All steps",
    filepath: "/Spring/steps.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
];
